import React from "react";

const Progress = props => {
	return (
		<div className="carousel-progress" onClick={props.clickHandler}>
			<div className="progress-wrap"><div className="progressbar" style={{ width: props.progressWidth }}></div></div>
		</div>
	)
}

export default Progress;